const transitionDurationMs = 100;
const closeButton = "_61c7l9jgl";
const backdrop = "_61b13nayi6";

export { backdrop, closeButton, transitionDurationMs };
import "./_abc-ordbogen.style.linaria.module.css";
//# sourceMappingURL=_abc-ordbogen.style.js.map
